import { Component, OnInit, Input } from '@angular/core';
import IActiveConnections = Authorization.IActiveConnections;

@Component({
    standalone: false,
  selector: 'app-active-connected-users-popup',
  templateUrl: './active-connected-users-popup.component.html',
  styleUrls: ['./active-connected-users-popup.component.scss']

})
export class ActiveConnectedUsersPopupComponent implements OnInit {
    @Input()
    connectedClients: IActiveConnections;

  constructor() { }

  ngOnInit() {
  }

}
